export default {
  common: {
    loading: 'Loading...',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    reset: 'Reset',
    back: 'Back',
    success: 'Success',
    error: 'Error',
    noData: 'No data',
    required: 'This field is required',
    language: 'Language',
  },
  nav: {
    home: 'Home',
    jobs: 'Jobs',
    profile: 'Profile',
    materials: 'Materials',
    agent: 'AI Assistant',
    settings: 'Settings',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
  },
  auth: {
    loginTitle: 'Login to Sugar Link',
    registerTitle: 'Register Sugar Link',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    forgotPassword: 'Forgot Password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    loginSuccess: 'Login successful',
    registerSuccess: 'Registration successful',
  },
  jobs: {
    title: 'Job List',
    searchPlaceholder: 'Search jobs, companies...',
    filter: 'Filter',
    city: 'City',
    cohortType: 'Recruitment Type',
    degreeReq: 'Degree Required',
    deadline: 'Deadline',
    employer: 'Company',
    apply: 'Apply',
    favorite: 'Favorite',
    unfavorite: 'Unfavorite',
    similar: 'Similar Jobs',
    description: 'Description',
    requirements: 'Requirements',
    skills: 'Skills',
  },
  profile: {
    title: 'Career Profile',
    basicInfo: 'Basic Info',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    educations: 'Education',
    experiences: 'Experience',
    projects: 'Projects',
    skills: 'Skills',
    save: 'Save Profile',
    parseResume: 'Upload Resume to Parse',
  },
  settings: {
    title: 'Account Settings',
    changePassword: 'Change Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    dataExport: 'Export My Data',
    deleteAccount: 'Delete Account',
  },
}
